export const environment = {
  production: false,
  
  // Used by nexchat-enterprise components
  apiUrl: 'https://api-dev.brainbotsdigital.com', 
  
  // Used by imported nexchat-core components (points to new enterprise backend)
  apiURL: 'https://api-dev.brainbotsdigital.com', 
  
  // Frontend URL for this enterprise app
  feURL: 'https://dev.brainbotsdigital.com', 
  
  // Facebook Pixel tracking config required by core services
  fbPixel: {
    enabled: false,
    id: ''
  }
};
